import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IngInputBase } from '../../inputs';

@Component({
  selector: 'ing-input-img-preview',
  templateUrl: './input-img-preview.component.html',
  styleUrls: ['./input-img-preview.component.scss']
})
export class InputImgPreviewComponent implements OnInit {
  @Input() form:  FormGroup;
  @Input() input: IngInputBase<any>;

  imgRoute: string;

  constructor() { }

  ngOnInit() {
    this.imgRoute = this.form.value[this.input.key];
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/ing-dynamic-form/dynamic-form/input-img-preview/input-img-preview.component.ts